import React from 'react';
import { connect } from 'react-redux';
import { withRouter, browserHistory } from 'react-router';

import styles from './Library.css';

class Library extends React.Component {
  componentDidMount() {
    const { location, permissions } = this.props;
    const isOutletLibraryPermission = currentValue =>
      currentValue.menu === 'Outlet Library';
    const permissionOutletLibrary = permissions.some(isOutletLibraryPermission);
    const targetURL = location.pathname.split('/');
    const currentUrl = targetURL[1].replace(/-/g, ' ');
    const currentLocationUrl =
      targetURL.length > 2 ? targetURL[2].replace(/-/g, ' ') : '';

    if (permissionOutletLibrary && currentUrl !== 'outlet library') {
      browserHistory.push(`/outlet-library/${currentLocationUrl}`);
    }

    if (!permissionOutletLibrary && currentUrl === 'outlet library') {
      browserHistory.push(`/library/${currentLocationUrl}`);
    }
  }

  render() {
    return <div className={`${styles.container}`}>{this.props.children}</div>;
  }
}

const mapStateToProps = state => {
  const {
    moka: { permissions },
  } = state;
  return {
    permissions,
  };
};

const connected = connect(mapStateToProps)(Library);

export default withRouter(connected);
